import { render, staticRenderFns } from "./CsButton.vue?vue&type=template&id=4126e01a&scoped=true&lang=pug&"
import script from "./CsButton.vue?vue&type=script&lang=js&"
export * from "./CsButton.vue?vue&type=script&lang=js&"
import style0 from "./CsButton.vue?vue&type=style&index=0&id=4126e01a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4126e01a",
  null
  
)

export default component.exports